import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
// import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";


export default function Topnavbar() {
  return (
    <div className="top-navbar-wrapper" style={{
      backgroundColor: '#24246E',
      minHeight: '45px',
      width: '100%',
      position: 'sticky',
      top: 0,
      zIndex: 1040,
      display: 'flex',
      alignItems: 'center',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      transition: 'all 0.3s ease'
    }}>
      <div className="container">
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%'
        }}>
          {/* Left Side: Careers | Blog */}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Link
              to="/Careers"
              className="top-nav-link"
              style={{
                color: 'rgba(255, 255, 255, 0.85)',
                textDecoration: 'none',
                fontSize: 'clamp(11px, 2.5vw, 13px)',
                fontWeight: '500',
                padding: '8px 12px',
                whiteSpace: 'nowrap'
              }}
            >
              Careers
            </Link>

            <span style={{ color: 'rgba(255, 255, 255, 0.15)', fontSize: '10px' }}>|</span>

            <Link
              to="/blogs"
              className="top-nav-link"
              style={{
                color: 'rgba(255, 255, 255, 0.85)',
                textDecoration: 'none',
                fontSize: 'clamp(11px, 2.5vw, 13px)',
                fontWeight: '500',
                padding: '8px 12px',
                whiteSpace: 'nowrap'
              }}
            >
              Blog
            </Link>
          </div>

          {/* Right Side: Email */}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <a
              href="mailto:info@safprotech.com"
              className="top-nav-link d-flex align-items-center"
              style={{
                color: 'rgba(255, 255, 255, 0.85)',
                textDecoration: 'none',
                fontSize: 'clamp(11px, 2.5vw, 13px)',
                fontWeight: '500',
                padding: '8px 12px',
                whiteSpace: 'nowrap'
              }}
            >
              <FontAwesomeIcon icon={faEnvelope} className='me-2' style={{ color: "#3b82f6", fontSize: '13px' }} />
              <span className="d-none d-sm-inline">info@safprotech.com</span>
              <span className="d-inline d-sm-none">Email</span>
            </a>
          </div>
        </div>
      </div>
      <style>{`
        .top-nav-link {
          transition: all 0.3s ease;
        }
        .top-nav-link:hover {
          color: #ffffff !important;
          background-color: rgba(255, 255, 255, 0.05);
        }
        @media (max-width: 991px) {
          .top-navbar-wrapper {
            min-height: 38px !important;
          }
          .top-nav-link {
            padding: 6px 8px !important;
          }
        }
        @media (max-width: 575px) {
          .top-navbar-wrapper {
            min-height: 35px !important;
          }
          .top-nav-link {
            padding: 4px 6px !important;
            font-size: 11px !important;
          }
          .container {
            padding-left: 10px;
            padding-right: 10px;
          }
        }
      `}</style>
    </div>
  )
}
